export const PUMP_SYSTEM_NO_RANGE_KEY = 'PS_NOS';

/**
 * Maps a controller name to the number range key used for the pump system field_no.
 *  - Hyphenated names use the family prefix: 'PS2-150' -> 'PS2', 'PSk2-15' -> 'PSK2', 'PSk3-7' -> 'PSK3'.
 *  - Non-hyphenated legacy PS names ('PS200', 'PS1800 Pool', 'PS9k2') -> 'PS'.
 *  - Any other name is used as-is (upper-cased), e.g. 'S1' -> 'S1'.
 */
export function fieldNoRangeKeyForController(controllerName: string | null | undefined): string | null {
  const name = (controllerName ?? '').trim();
  if (!name || name === 'undefined' || name === 'null') {
    return null;
  }
  const hyphen = name.indexOf('-');
  if (hyphen > 0) {
    return name.slice(0, hyphen).trim().toUpperCase();
  }
  if (/^PS/i.test(name)) {
    return 'PS';
  }
  return name.toUpperCase();
}
